import {
  Box,
  ListItemIcon,
  MenuItem,
  MenuItemProps,
  Tooltip,
  useTheme,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { ReactNode, useCallback } from "react";
import { useMatch, useNavigate, useResolvedPath } from "react-router-dom";
import { useStores } from "../../../mobx-stores/_root-store";

type NavigationItemProps = MenuItemProps & {
  to: string;
  icon?: ReactNode;
};

export const NavigationItem = observer(
  ({ to, icon, ...props }: NavigationItemProps) => {
    const { mainNavigationMinimize, setProp } = useStores();
    let resolved = useResolvedPath(to);
    const match = useMatch({ path: `${resolved.pathname}/*` });
    const navigate = useNavigate();
    const theme = useTheme();
    const onItemClicked = useCallback(() => {
      setProp("mainNavigationMinimize", false);
      navigate(to);
    }, [navigate, setProp, to]);
    return (
      <Tooltip
        title={mainNavigationMinimize ? props.children : ""}
        placement="right"
      >
        <MenuItem
          onClick={onItemClicked}
          {...props}
          sx={{
            ...props.sx,
            minHeight: "48px",
            minWidth: "50px",
            padding: "4px 10px",
            borderTopRightRadius: "8px",
            borderBottomRightRadius: "8px",
            "&.Mui-selected": {
              backgroundColor: theme.palette.secondary.main,
            },
            fontWeight: theme.typography.fontWeightMedium,
          }}
          selected={match ? true : false}
        >
          <ListItemIcon sx={{ color: "#1B1B1F", minWidth: "20px !important" }}>
            {icon}
          </ListItemIcon>

          {!mainNavigationMinimize && (
            <Box
              sx={{
                minWidth: "150px",
                maxWidth: "250px",
                marginLeft: "15px",
                textTransform: "capitalize",
              }}
            >
              {props.children}
            </Box>
          )}
        </MenuItem>
      </Tooltip>
    );
  }
);
